/* eslint-disable max-len */
import classNames from 'classnames';
import React from 'react';

export const ListIcon = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => {
  return (
    <i className={classNames('bookriver-icon-ListIcon', className)} {...props} />
  );
};
